import styled from 'styled-components';
import ArrowBackIos from '@material-ui/icons/ArrowBackIos';
import { makeStyles } from '@material-ui/core';

import THEME from '../../../../../constants/theme';


export const BookingCode = styled.p`
  color: ${THEME.grey};
  flex: 1;
  justify-self: center;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: 0.2px;
  margin: 0;
`;

export const IconBack = styled(ArrowBackIos)`
  color: ${THEME.grey};

  &:hover {
    cursor: pointer;
  }
`;

export const StatusText = styled.p`
  align-items: center;
  border: 1px solid ${props => props.color};
  border-radius: 12px;
  color: ${props => props.color};
  display: flex;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  justify-content: center;
  letter-spacing: 0.5px;
  margin: 0;
  padding: 0 10px;
  min-width: 88px;
`;

// TODO: Replace colors with material-ui colors
export const useHeaderStyles = makeStyles(theme => ({
  root: {
    display                     : 'flex',
    borderBottom                : `1px solid ${THEME.lightGrey}`,
    minHeight                   : '67.5px',
    alignItems                  : 'center',
    flexWrap                    : 'wrap',
    gap                         : 0,
    [theme.breakpoints.up('sm')]: {
      gap: theme.spacing(0, 4),
    },
  },

}));
